import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'antd'

import css from '../styles.css'

const ExtraQuestionButtons = ({
  extraQuestions,
  handleAddExtraQuestion,
  handleDeleteExtraQuestion,
}) => (
  <div className={css.extraQuestionButtonContainer}>
    <Button
      onClick={handleAddExtraQuestion}
      disabled={extraQuestions.length >= 2}
    >
      {'Add Extra Question'}
    </Button>
    <Button
      onClick={handleDeleteExtraQuestion}
      disabled={extraQuestions.length < 2}
    >
      {'Delete Extra Question'}
    </Button>
  </div>
)

ExtraQuestionButtons.propTypes = {
  extraQuestions: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleAddExtraQuestion: PropTypes.func.isRequired,
  handleDeleteExtraQuestion: PropTypes.func.isRequired,
}

export default ExtraQuestionButtons



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/ExtraQuestions/ExtraQuestionButtons.js